import { Link } from "react-router-dom";
import { ArrowLeft, ArrowUpRight, Play, Search, Menu, X } from "lucide-react";
import { useState } from "react";
import { useT, LangToggle } from "../i18n/LanguageContext";

const LOGO = "https://customer-assets.emergentagent.com/job_equality-hub-7/artifacts/3m4xmkko_mother%20hippo%20PNG.png";
const IMG_WOMEN = "https://customer-assets.emergentagent.com/job_equality-hub-7/artifacts/1avalk56_Screenshot%202026-04-30%20at%201.12.32%E2%80%AFPM.png";
const STOP_FGM = "https://customer-assets.emergentagent.com/job_equality-hub-7/artifacts/k1wg42ea_IMG-20260408-WA0020.jpg";
const IMG_SELIFA = "https://customer-assets.emergentagent.com/job_equality-hub-7/artifacts/cn9nk1cb_Screenshot%202026-04-30%20at%201.12.37%E2%80%AFPM.png";
const IMG_COMMUNITY = "https://customer-assets.emergentagent.com/job_equality-hub-7/artifacts/4b9z0d2l_Screenshot%202026-04-30%20at%201.12.43%E2%80%AFPM.png";

const copy = {
  en: {
    back: "Selector",
    menu: "Menu",
    close: "Close",
    navItems: ["Programme", "Explore", "Charter", "About", "Support"],
    heroTitle: "If we don't speak up,",
    heroTitleItalic: "who will?",
    showreel: "MHF showreel",
    showreelDur: "00:42",
    newsletter: "Subscribe to our Newsletter",
    newsletterShow: "Show Newsletter Signup",
    whatsOn: "What's on",
    whatsOnCount: "02",
    programmes: [
      {
        type: "Project",
        dates: "20 Jan — 10 Feb 2026",
        title: "FGM Advocacy Tour : 22 Days, 12 Cities, One Voice",
        img: IMG_WOMEN,
      },
      {
        type: "Campaign",
        dates: "Across 18 African countries · Jan—Feb 2026",
        title: "Voices Across Borders : Influencer Campaign Against FGM",
        img: IMG_COMMUNITY,
      },
    ],
    upcoming: "Upcoming",
    upcomingCount: "01",
    upcomingItems: [
      {
        type: "Workshop · Completed",
        dates: "1 — 4 April 2026 · Tindjassi Sarakawa · Djarkpanga · Boulohou",
        title: "Mother Hippo Workshop : Mission Against FGM — three Togolese villages, dozens of survivor-led conversations",
        img: IMG_WOMEN,
      },
    ],
    discover: "Discover",
    discoverMore: "Discover more",
    discoverItems: [
      { type: "Publication", date: "Apr 16, 2025", title: "Publication: Ending Cutting in a Generation — A Primer" },
      { type: "Performance", date: "Feb 4, 2026", title: "LULLABY FOR A SCALPEL: A Sonic Memorial feat. Debit" },
      { type: "In Conversation", date: "Jan 30, 2026", title: "The Quiet Revolution: Conversations on Care" },
      { type: "Digital Booklet", date: "Jan 22, 2026", title: "Digital Booklet: Anatomy of Consent" },
    ],
    missionKicker: "OUR MISSION",
    missionHeading: "Mother Hippo Foundation, founded in 2018 by FGM survivor Sélifa Boukari McGreevy, exists to educate and raise awareness against FGM — to eradicate this practice within a generation.",
    missionLink: "Explore our Charter",
    onlineKicker: "MHF Online",
    onlineHead: "MHF Online Programme",
    onlineBody: "Artists, clinicians and survivors have been authoring internet-based works on bodily autonomy since the invention of the World Wide Web. Today's landscape spans digital media, interactive storytelling, and augmented reality.",
    onlineLink: "Find out more",
    onlineAbout: "About MHF Online Programme",
    followUs: "Follow us",
    socials: [
      { name: "Instagram", img: IMG_WOMEN },
      { name: "TikTok", img: IMG_SELIFA },
      { name: "Facebook", img: IMG_COMMUNITY },
      { name: "LinkedIn", img: IMG_WOMEN },
      { name: "YouTube", img: IMG_COMMUNITY },
    ],
    cookieTitle: "Cookie-Banner",
    cookieHead: "Choose your cookies",
    cookieBody: "We use cookies to keep our website functional, enhance your experience, and improve our content. You can choose which categories to activate.",
    cookieAccept: "Accept All",
    cookieRequired: "Only Required",
    cookieCustom: "Customize Settings",
    joinKicker: "Join our newsletter to stay up to date",
    joinAgree: "I agree to receive communications from Mother Hippo Foundation.",
    joinCta: "Sign Up",
    joinEmail: "Your email",
    footerOrg: "Mother Hippo Foundation",
    footerAddr: "Las Vegas, Nevada · Lomé, Togo",
    rights: "© 2026 Mother Hippo Foundation",
  },
  fr: {
    back: "Sélecteur",
    menu: "Menu",
    close: "Fermer",
    navItems: ["Programme", "Explorer", "Charte", "À propos", "Soutenir"],
    heroTitle: "Si nous ne parlons pas,",
    heroTitleItalic: "qui le fera ?",
    showreel: "Bande-annonce MHF",
    showreelDur: "00:42",
    newsletter: "S'abonner à la lettre",
    newsletterShow: "Afficher l'inscription",
    whatsOn: "À l'affiche",
    whatsOnCount: "02",
    programmes: [
      {
        type: "Projet",
        dates: "20 janv — 10 févr 2026",
        title: "Tournée de Plaidoyer MGF : 22 Jours, 12 Villes, Une Voix",
        img: IMG_WOMEN,
      },
      {
        type: "Campagne",
        dates: "Dans 18 pays africains · janv—févr 2026",
        title: "Voix Sans Frontières : Campagne d'Influenceuses Contre les MGF",
        img: IMG_COMMUNITY,
      },
    ],
    upcoming: "À venir",
    upcomingCount: "01",
    upcomingItems: [
      {
        type: "Atelier · Réalisé",
        dates: "1 — 4 avril 2026 · Tindjassi Sarakawa · Djarkpanga · Boulohou",
        title: "Atelier Mother Hippo : Mission Contre les MGF — trois villages togolais, des dizaines de conversations menées par des survivantes",
        img: IMG_WOMEN,
      },
    ],
    discover: "Découvrir",
    discoverMore: "Découvrir plus",
    discoverItems: [
      { type: "Publication", date: "16 avr 2025", title: "Publication : Mettre fin à l'excision en une génération — Un abécédaire" },
      { type: "Performance", date: "4 févr 2026", title: "BERCEUSE POUR UN SCALPEL : Un Mémorial Sonore feat. Debit" },
      { type: "En Conversation", date: "30 janv 2026", title: "La Révolution Tranquille : Conversations sur le soin" },
      { type: "Livret Numérique", date: "22 janv 2026", title: "Livret Numérique : Anatomie du Consentement" },
    ],
    missionKicker: "NOTRE MISSION",
    missionHeading: "La Mother Hippo Foundation, fondée en 2018 par Sélifa Boukari McGreevy, survivante des MGF, existe pour éduquer et sensibiliser contre les MGF — afin d'éradiquer cette pratique en une génération.",
    missionLink: "Explorer notre Charte",
    onlineKicker: "MHF En Ligne",
    onlineHead: "Programme MHF En Ligne",
    onlineBody: "Artistes, cliniciens et survivantes créent des œuvres en ligne sur l'autonomie corporelle depuis l'invention du Web. Le paysage actuel couvre médias numériques, récits interactifs et réalité augmentée.",
    onlineLink: "En savoir plus",
    onlineAbout: "À propos du Programme MHF En Ligne",
    followUs: "Suivez-nous",
    socials: [
      { name: "Instagram", img: IMG_WOMEN },
      { name: "TikTok", img: IMG_SELIFA },
      { name: "Facebook", img: IMG_COMMUNITY },
      { name: "LinkedIn", img: IMG_WOMEN },
      { name: "YouTube", img: IMG_COMMUNITY },
    ],
    cookieTitle: "Bandeau-Cookies",
    cookieHead: "Choisissez vos cookies",
    cookieBody: "Nous utilisons des cookies pour faire fonctionner le site, améliorer votre expérience et notre contenu. Vous pouvez choisir les catégories à activer.",
    cookieAccept: "Tout accepter",
    cookieRequired: "Nécessaires uniquement",
    cookieCustom: "Personnaliser",
    joinKicker: "Inscrivez-vous à notre lettre",
    joinAgree: "J'accepte de recevoir des communications de la Mother Hippo Foundation.",
    joinCta: "S'inscrire",
    joinEmail: "Votre courriel",
    footerOrg: "Mother Hippo Foundation",
    footerAddr: "Las Vegas, Nevada · Lomé, Togo",
    rights: "© 2026 Mother Hippo Foundation",
  },
};

export default function PrototypeCurated() {
  const t = useT(copy);
  const [menuOpen, setMenuOpen] = useState(false);
  const [cookieOpen, setCookieOpen] = useState(true);

  return (
    <div
      data-testid="prototype-curated"
      className="min-h-screen bg-white text-black selection:bg-black selection:text-white"
      style={{ fontFamily: "'Inter', 'DM Sans', sans-serif", fontFeatureSettings: '"ss01"' }}
    >
      {/* Header — LAS-style: minimal, top bar with logo + Menu + Search */}
      <header className="sticky top-0 z-50 bg-white border-b border-black/10">
        <div className="flex items-center justify-between px-5 md:px-8 h-14">
          <Link
            to="/"
            className="flex items-center gap-2 text-[11px] tracking-[0.15em] uppercase hover:opacity-60 transition-opacity"
            data-testid="back-to-selector"
          >
            <ArrowLeft size={13} />
            {t.back}
          </Link>
          <img src={LOGO} alt="Mother Hippo Foundation" className="h-8 w-auto object-contain" />
          <div className="flex items-center gap-4">
            <button className="hidden md:inline-flex items-center gap-1.5 text-[11px] tracking-[0.15em] uppercase hover:opacity-60" data-testid="curated-search">
              <Search size={13} />
              Search
            </button>
            <LangToggle testId="curated-lang-toggle" />
            <button
              onClick={() => setMenuOpen(true)}
              className="inline-flex items-center gap-1.5 text-[11px] tracking-[0.15em] uppercase hover:opacity-60"
              data-testid="curated-menu-open"
            >
              <Menu size={14} />
              {t.menu}
            </button>
          </div>
        </div>
      </header>

      {/* Full-screen menu overlay */}
      {menuOpen && (
        <div
          className="fixed inset-0 z-[60] bg-white"
          data-testid="curated-menu-overlay"
        >
          <div className="flex items-center justify-between px-5 md:px-8 h-14 border-b border-black/10">
            <img src={LOGO} alt="" className="h-8 w-auto object-contain" />
            <button
              onClick={() => setMenuOpen(false)}
              className="inline-flex items-center gap-1.5 text-[11px] tracking-[0.15em] uppercase hover:opacity-60"
              data-testid="curated-menu-close"
            >
              <X size={14} />
              {t.close}
            </button>
          </div>
          <div className="px-5 md:px-16 py-16 md:py-20">
            <ul className="space-y-6">
              {t.navItems.map((item, i) => (
                <li key={i}>
                  <a
                    href={`#${item.toLowerCase()}`}
                    onClick={() => setMenuOpen(false)}
                    className="group inline-flex items-center gap-4 text-5xl md:text-7xl lg:text-8xl tracking-[-0.02em] hover:text-[#E3282B] transition-colors"
                  >
                    <span className="text-base md:text-xl opacity-40">{String(i + 1).padStart(2, "0")}</span>
                    <span>{item}</span>
                    <ArrowUpRight className="opacity-0 group-hover:opacity-100 transition-opacity" size={32} />
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}

      {/* Hero — full-bleed showreel */}
      <section className="relative">
        <div className="relative w-full bg-white flex items-center justify-center py-8 md:py-12 border-b border-black/10">
          <img src={STOP_FGM} alt="STOP Female Genital Mutilation — Mother Hippo Foundation campaign banner" className="w-full max-w-5xl h-auto" data-testid="curated-stop-fgm-banner" />
        </div>

        {/* Hero headline — on white directly below showreel */}
        <div className="px-5 md:px-8 py-14 md:py-24 border-b border-black/10">
          <h1
            data-testid="curated-hero-title"
            className="font-[inherit] text-[#0a0a0a] text-6xl sm:text-7xl md:text-8xl lg:text-[160px] leading-[0.95] tracking-[-0.035em] font-medium max-w-6xl"
          >
            {t.heroTitle}<br />
            <em className="italic font-normal" style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 500 }}>
              {t.heroTitleItalic}
            </em>
          </h1>
          <div className="mt-10 flex items-center justify-between flex-wrap gap-4">
            <button
              className="inline-flex items-center gap-2 text-[11px] tracking-[0.2em] uppercase border-b border-black pb-1 hover:opacity-60 transition-opacity"
              data-testid="curated-newsletter-toggle"
            >
              {t.newsletter} <span className="opacity-40">{t.newsletterShow}</span>
            </button>
          </div>
        </div>
      </section>

      {/* What's on */}
      <section id="programme" className="px-5 md:px-8 py-16 md:py-20 border-b border-black/10">
        <div className="flex items-start justify-between mb-12 md:mb-16">
          <h2 className="text-5xl sm:text-6xl md:text-8xl lg:text-9xl tracking-[-0.035em] font-medium leading-none">
            {t.whatsOn}
          </h2>
          <div className="text-5xl sm:text-6xl md:text-8xl lg:text-9xl tracking-[-0.035em] opacity-20 leading-none">
            {t.whatsOnCount}
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-8">
          {t.programmes.map((p, i) => (
            <a
              key={i}
              href="#"
              data-testid={`curated-programme-${i}`}
              className="group block"
            >
              <div className="relative overflow-hidden bg-black">
                <img
                  src={p.img}
                  alt={p.title}
                  className="w-full aspect-[4/3] object-cover transition-transform duration-[1200ms] group-hover:scale-105"
                />
              </div>
              <div className="mt-4 flex items-center gap-3 text-[11px] tracking-[0.15em] uppercase opacity-70">
                <span>{p.type}</span>
                <span>|</span>
                <span>{p.dates}</span>
              </div>
              <h3 className="mt-2.5 text-2xl md:text-3xl tracking-[-0.02em] leading-[1.15] font-medium group-hover:opacity-60 transition-opacity">
                {p.title}
              </h3>
            </a>
          ))}
        </div>
      </section>

      {/* Upcoming */}
      <section className="px-5 md:px-8 py-16 md:py-20 border-b border-black/10">
        <div className="flex items-start justify-between mb-12 md:mb-16">
          <h2 className="text-5xl sm:text-6xl md:text-8xl lg:text-9xl tracking-[-0.035em] font-medium leading-none">
            {t.upcoming}
          </h2>
          <div className="text-5xl sm:text-6xl md:text-8xl lg:text-9xl tracking-[-0.035em] opacity-20 leading-none">
            {t.upcomingCount}
          </div>
        </div>
        {t.upcomingItems.map((p, i) => (
          <a
            key={i}
            href="#"
            data-testid={`curated-upcoming-${i}`}
            className="group block"
          >
            <div className="relative overflow-hidden bg-black">
              <img
                src={p.img}
                alt={p.title}
                className="w-full aspect-[21/9] object-cover transition-transform duration-[1200ms] group-hover:scale-105"
              />
            </div>
            <div className="mt-4 flex items-center gap-3 text-[11px] tracking-[0.15em] uppercase opacity-70">
              <span>{p.type}</span>
              <span>|</span>
              <span>{p.dates}</span>
            </div>
            <h3 className="mt-2.5 text-2xl md:text-4xl tracking-[-0.02em] leading-[1.1] font-medium group-hover:opacity-60 transition-opacity max-w-4xl">
              {p.title}
            </h3>
          </a>
        ))}
      </section>

      {/* Mission — overlay on image (LAS does this) */}
      <section id="mission" className="relative overflow-hidden border-b border-black/10 bg-black">
        <img src={IMG_COMMUNITY} alt="" className="absolute inset-0 w-full h-full object-cover opacity-60" />
        <div className="relative px-5 md:px-8 py-24 md:py-40 max-w-5xl">
          <div className="text-[11px] tracking-[0.2em] uppercase text-white/90">{t.missionKicker}</div>
          <p className="mt-8 text-white text-2xl md:text-4xl lg:text-5xl leading-[1.15] tracking-[-0.015em] font-medium">
            {t.missionHeading}
          </p>
          <a
            href="#"
            className="mt-10 inline-flex items-center gap-2 text-sm text-white border-b border-white pb-0.5 hover:opacity-60 transition-opacity"
            data-testid="curated-charter-link"
          >
            {t.missionLink} <ArrowUpRight size={14} />
          </a>
        </div>
      </section>

      {/* Discover */}
      <section id="explore" className="px-5 md:px-8 py-16 md:py-20 border-b border-black/10">
        <div className="flex items-start justify-between mb-12 md:mb-16">
          <h2 className="text-4xl md:text-5xl tracking-[-0.02em] font-medium">{t.discover}</h2>
          <a href="#" className="text-sm underline underline-offset-4 hover:opacity-60 transition-opacity">
            {t.discoverMore}
          </a>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {t.discoverItems.map((d, i) => {
            const imgs = [IMG_SELIFA, IMG_WOMEN, IMG_COMMUNITY, IMG_SELIFA];
            return (
              <a
                key={i}
                href="#"
                data-testid={`curated-discover-${i}`}
                className="group block"
              >
                <div className="relative overflow-hidden bg-black">
                  <img
                    src={imgs[i]}
                    alt=""
                    className="w-full aspect-square object-cover transition-transform duration-[1200ms] group-hover:scale-105"
                  />
                </div>
                <div className="mt-3 flex items-center gap-2 text-[10px] tracking-[0.15em] uppercase opacity-70">
                  <span>{d.type}</span>
                  <span>|</span>
                  <span>{d.date}</span>
                </div>
                <h3 className="mt-2 text-base md:text-lg tracking-[-0.01em] font-medium leading-[1.25] group-hover:opacity-60 transition-opacity">
                  {d.title}
                </h3>
              </a>
            );
          })}
        </div>
      </section>

      {/* MHF Online Programme — image + text split */}
      <section id="about" className="px-5 md:px-8 py-16 md:py-24 border-b border-black/10 grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16 items-center">
        <div className="relative overflow-hidden bg-black aspect-[4/3]">
          <img src={IMG_COMMUNITY} alt="" className="w-full h-full object-cover" />
        </div>
        <div>
          <div className="text-[11px] tracking-[0.2em] uppercase opacity-70">{t.onlineKicker}</div>
          <h3 className="mt-4 text-3xl md:text-5xl tracking-[-0.02em] font-medium leading-[1.05]">
            {t.onlineHead}
          </h3>
          <p className="mt-6 text-base md:text-lg leading-relaxed opacity-80 max-w-lg">
            {t.onlineBody}
          </p>
          <a
            href="#"
            className="mt-8 inline-flex items-center gap-2 text-sm border-b border-black pb-0.5 hover:opacity-60 transition-opacity"
            data-testid="curated-online-link"
          >
            {t.onlineLink} <span className="opacity-50">{t.onlineAbout}</span> <ArrowUpRight size={14} />
          </a>
        </div>
      </section>

      {/* Follow us — LAS-style video-thumbnail social tiles */}
      <section className="px-5 md:px-8 py-16 md:py-20 border-b border-black/10">
        <div className="text-[11px] tracking-[0.2em] uppercase mb-8">{t.followUs}</div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-3 md:gap-4">
          {t.socials.map((s, i) => (
            <a
              key={i}
              href="#"
              data-testid={`curated-social-${i}`}
              className="group relative block overflow-hidden bg-black aspect-[4/5]"
            >
              <img
                src={s.img}
                alt={s.name}
                className="w-full h-full object-cover transition-transform duration-[1200ms] group-hover:scale-105 opacity-80 group-hover:opacity-100"
              />
              <div className="absolute bottom-3 left-3 text-white text-xs tracking-[0.15em] uppercase font-medium">
                {s.name}
              </div>
            </a>
          ))}
        </div>
      </section>

      {/* Newsletter */}
      <section id="support" className="px-5 md:px-8 py-16 md:py-20 border-b border-black/10 grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16">
        <div className="flex items-start gap-6">
          <img
            src={IMG_SELIFA}
            alt=""
            className="w-24 h-24 md:w-32 md:h-32 object-cover shrink-0"
          />
          <div>
            <div className="text-[11px] tracking-[0.2em] uppercase opacity-70">Programme</div>
            <div className="mt-2 text-xl md:text-2xl tracking-[-0.01em] font-medium">
              Digital Booklet: Anatomy of Consent
            </div>
            <a
              href="#"
              className="mt-4 inline-flex items-center gap-1.5 text-sm border-b border-black pb-0.5 hover:opacity-60"
            >
              Read <ArrowUpRight size={14} />
            </a>
          </div>
        </div>
        <div>
          <div className="text-2xl md:text-3xl tracking-[-0.02em] font-medium leading-tight">
            {t.joinKicker}
          </div>
          <form
            className="mt-6 flex flex-col sm:flex-row gap-3 max-w-md"
            onSubmit={(e) => e.preventDefault()}
          >
            <input
              type="email"
              placeholder={t.joinEmail}
              data-testid="curated-newsletter-email"
              className="flex-1 px-4 py-3 border border-black/20 bg-white text-sm focus:outline-none focus:border-black"
            />
            <button
              type="submit"
              data-testid="curated-newsletter-submit"
              className="px-6 py-3 bg-black text-white text-[11px] tracking-[0.2em] uppercase hover:bg-[#E3282B] transition-colors"
            >
              {t.joinCta}
            </button>
          </form>
          <label className="mt-4 flex items-start gap-2 text-xs opacity-70 max-w-md cursor-pointer">
            <input type="checkbox" className="mt-0.5" data-testid="curated-newsletter-consent" />
            <span>{t.joinAgree}</span>
          </label>
        </div>
      </section>

      {/* Footer */}
      <footer className="px-5 md:px-8 py-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
        <div className="flex items-center gap-4">
          <img src={LOGO} alt="" className="h-8 w-auto object-contain" />
          <div className="text-[11px] tracking-[0.15em] uppercase">
            {t.footerOrg} · {t.footerAddr}
          </div>
        </div>
        <div className="text-[11px] tracking-[0.15em] uppercase opacity-70">{t.rights}</div>
      </footer>

      {/* Cookie banner — LAS has one */}
      {cookieOpen && (
        <div
          className="fixed bottom-5 left-5 right-5 md:left-8 md:right-auto md:max-w-md z-40 bg-white border border-black shadow-[8px_8px_0_0_#000] p-6"
          data-testid="curated-cookie-banner"
        >
          <div className="flex items-center justify-between mb-3">
            <div className="text-[11px] tracking-[0.2em] uppercase font-medium">{t.cookieTitle}</div>
            <button
              onClick={() => setCookieOpen(false)}
              className="opacity-60 hover:opacity-100"
              data-testid="curated-cookie-close"
              aria-label="Close"
            >
              <X size={16} />
            </button>
          </div>
          <div className="text-lg font-medium mb-2">{t.cookieHead}</div>
          <p className="text-xs opacity-75 leading-relaxed">{t.cookieBody}</p>
          <div className="mt-4 flex flex-wrap gap-2">
            <button
              onClick={() => setCookieOpen(false)}
              data-testid="curated-cookie-accept"
              className="px-4 py-2 bg-black text-white text-[11px] tracking-[0.15em] uppercase hover:bg-[#E3282B] transition-colors"
            >
              {t.cookieAccept}
            </button>
            <button
              onClick={() => setCookieOpen(false)}
              className="px-4 py-2 border border-black text-[11px] tracking-[0.15em] uppercase hover:bg-black hover:text-white transition-colors"
            >
              {t.cookieRequired}
            </button>
            <button
              className="px-4 py-2 text-[11px] tracking-[0.15em] uppercase underline underline-offset-4 hover:opacity-60"
            >
              {t.cookieCustom}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
